import React, {useCallback, useEffect, useMemo, useState} from 'react';
import FieldScreenComponent from "../FieldScreenComponent";
import {errorHandler} from "../../../../../Utils/Form/FormDynamic/Utils/errorHandler";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import request from "../../../../../Services/API/Requests";
import asyncForEach from "../../../../../Utils/Form/FormDynamic/Utils/asyncForEach";
import formatValue from "../../../../../Utils/ListUtils/FormatValue";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    flexCell: {
        border: '1px solid #f2f2f2',
        outline: 'none',
        position: 'relative',
        '&:focus': {
            border: `1px solid ${theme.palette.primary.main}`
        },
    },
    flexCellSelected: {
        boxShadow: '0 2px 6px 2px rgba(60,64,67,.15)',
        font: 'caption',
        outline: 'none',
        position: 'relative',
        border: `1px solid ${theme.palette.primary.main} !important`,
        '&:focus': {
            outline: 'none'
        },
        paddingLeft: 4,
        paddingRight: 4,
    },
    flexCellError: {
        outline: 'none',
        position: 'relative',
        boxShadow: '0 2px 6px 2px rgba(60,64,67,.15)',
        font: 'caption',
        border: `1px solid ${theme.palette.secondary.main} !important`,
        '&:focus': {
            outline: 'none'
        },
        paddingLeft: 4,
        paddingRight: 4,
    },
    errText: {color: 'red', fontSize: '0.8rem'}
}));

//utils
const getLabel = async (entity, value, isArray) => {
    if (!isArray) {
        try {
            let getLabel = await request({
                url: `system/getLabel`,
                method: 'POST',
                data: {entity, id: value}
            });
            return getLabel.label;
        } catch (e) {
            console.log(e);
            return value
        }
    } else {
        let currentValue = [];
        await asyncForEach(value, async (id) => {
            try {
                let getLabel = await request({
                    url: `system/getLabel`,
                    method: 'POST',
                    data: {entity, id}
                });
                currentValue.push({label: getLabel.label, value: id});
            } catch (e) {
                currentValue.push({label: id, value: id});
                console.log(e);
            }
        });
        return currentValue;
    }

};

function convertInTextValue(value, type) {
    return formatValue(value, type, undefined);
}

const frequencyToText = async (value) => {
    if (value) {
        try {
            return await request({
                url: '/core/frequencyToText',
                method: 'POST',
                data: value
            });
        } catch (e) {
            console.log(e)
        }
    } else {
        return '';
    }
};

const TableCell = (props) => {
    const {
        id, field, indexValue, newPath,
        fieldErrors, isHidden, setActiveCell, globalValues, screenName,
        field: {properties: {schema, type, entity, isArray, path}},
    } = props;

    const [currentField, setCurrentField] = useState(null);
    const [cellValue, setCellValue] = useState(null);
    const classes = useStyles();
    const isSelected = JSON.stringify(currentField) === JSON.stringify(field);
    const isNumber = type === 'integer' || type === 'number';
    const fullPath = `${newPath}.${path}`;
    const errorText = errorHandler(fieldErrors, fullPath);
    const value = findByString(globalValues.param[screenName], fullPath);
    const styles = field.styles ? field.styles[0] : {};


    useEffect(() => {
        async function setValue() {
            const value = await setValueCell();
            setCellValue(value)
        }

        setValue();
    }, []);

    //set value on update field value
    useEffect(() => {
        async function setValue() {
            const value = await setValueCell();
            setCellValue(value)
        }

        setValue();
    }, [value]);


    async function setValueCell() {
        //let isEnrichment = schema && schema.labelFields && schema.labelFields.length;
        let fValue = findByString(globalValues.param[screenName], fullPath);

        if (type === 'entityExternal' && fValue) {
            fValue = await getLabel(entity, findByString(globalValues.param[screenName], fullPath), isArray)
        }
        if (type === 'frequency') {
            let freqValue = await frequencyToText(fValue);
            fValue = freqValue.text
        }
        return convertInTextValue(fValue, type);
    }

    function setStyle(errorText) {
        if (isSelected) {
            return classes.flexCellSelected
        } else if (errorText.length > 0) {
            return classes.flexCellError
        } else {
            return classes.flexCell
        }
    }

    const onCellClick = (currentField, index, id) => {
        setCurrentField(currentField);
        setActiveCell(true, id)
    };
    const onCellKeyDown = (event, currentField, index, id) => {
        if (event.ctrlKey && event.key === 'Insert' && isSelected) {
            event.stopPropagation();
        }
        if (event.key.length === 1 && event.key.match(/[a-z0-9]/i) && !event.ctrlKey) {
            setCurrentField(currentField);
            setActiveCell(true, id)
        }
        if (event.key === 'F2' || event.key === 'Enter') {
            event.preventDefault();
            setCurrentField(currentField);
            setActiveCell(true, id)
        }
        if (event.key === 'Escape') {
            event.stopPropagation();
            setCurrentField(null);
            setActiveCell(false)
        }
        if (event.key === 'Enter') {
            if (currentField) {
                document.getElementById(id).blur();
                let currentFocus = id.split('_');
                currentFocus.splice(1, 1, +currentFocus[1] + 1);
                let newFocus = currentFocus.join('_');
                if (document.getElementById(newFocus)) {
                    setActiveCell(false);
                    setCurrentField(currentField);
                    document.getElementById(newFocus).focus();
                } else {
                    currentFocus.splice(1, 1, currentFocus[1] = 1);
                    currentFocus.splice(0, 1, +currentFocus[0] + 1);
                    let newFocus = currentFocus.join('_');
                    if (document.getElementById(newFocus)) {
                        setActiveCell(false);
                        setCurrentField(null);
                        document.getElementById(newFocus).focus();
                    }
                }
            }

        }
    };

    const onCellBlur = useCallback(() => {
        setCurrentField(null);
        setActiveCell(false)
    }, [])

    const fieldValues = useMemo(() => {
        return {
            ...field,
            properties: {...field.properties, path: fullPath, autofocus: true}
        }
    }, [JSON.stringify(field)])

    return (
        <div className={setStyle(errorText)}
             style={{
                 textAlign: isNumber ? 'right' : 'left',
                 whiteSpace: 'nowrap',
                 textOverflow: 'ellipsis',
                 overflow: 'hidden',
                 display: isHidden ? 'none' : 'block',
                 width: styles.width || 'auto',
                 padding: '0 1px'
             }}
             id={id}
             tabIndex={0}
             onClick={() => setActiveCell(true, id)}
             onDoubleClick={() => onCellClick(field, indexValue, id)}
             onKeyDown={(event) => onCellKeyDown(event, field, indexValue, id)}>
            {isSelected ? (
                <FieldScreenComponent
                    focusNow={true}
                    showLabel={true}
                    onBlurFromCell={onCellBlur}
                    field={fieldValues}
                />
            ) : (
                <>
                    <Typography component={'span'}>{cellValue}</Typography>
                    {errorText.length > 0 && (
                        <>
                            <br/>
                            <span className={classes.errText}>{errorText}</span>
                        </>
                    )}
                </>
            )}
        </div>
    )
};
export default JsonScreenHoc(TableCell)